// components/ClarityConsentBanner.tsx
import { Box, Button, IconButton, Link, Paper, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BarChartIcon from "@mui/icons-material/BarChart";
import { useClarityConsent } from "@/hooks/useClarity";

export const ClarityConsentBanner = () => {
  const { showBanner, acceptConsent, declineConsent } = useClarityConsent();

  if (!showBanner) return null;

  return (
    <Paper
      elevation={8}
      sx={{
        position: "fixed",
        bottom: 24,
        right: 24,
        width: 400,
        maxWidth: "calc(100vw - 48px)",
        borderRadius: 3,
        overflow: "hidden",
        zIndex: 1400,
      }}
    >
      {/* Header accent */}
      <Box sx={{ height: 4, bgcolor: "primary.main" }} />

      <Box sx={{ p: 3 }}>
        {/* Close button */}
        <IconButton
          onClick={declineConsent}
          size="small"
          sx={{ position: "absolute", top: 12, right: 12, color: "text.secondary" }}
          aria-label="Decline analytics"
        >
          <CloseIcon fontSize="small" />
        </IconButton>

        {/* Icon and title */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 1.5, pr: 4 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 2,
              bgcolor: "primary.main",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "primary.contrastText",
            }}
          >
            <BarChartIcon fontSize="small" />
          </Box>
          <Typography variant="subtitle1" fontWeight={600}>
            Help us improve Aegle Claims Platform
          </Typography>
        </Box>

        {/* Description */}
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.6 }}>
          We use Microsoft Clarity to understand how you use the platform. Session recordings help us identify issues
          and improve your experience. No sensitive data is captured.{" "}
          <Link
            href="https://learn.microsoft.com/en-us/clarity/faq"
            target="_blank"
            rel="noopener noreferrer"
            sx={{ fontWeight: 500 }}
          >
            Learn more
          </Link>
        </Typography>

        {/* Buttons */}
        <Box sx={{ display: "flex", gap: 1.5, justifyContent: "flex-end" }}>
          <Button onClick={declineConsent} color="inherit" sx={{ color: "text.secondary" }}>
            No thanks
          </Button>
          <Button onClick={acceptConsent} variant="contained" disableElevation>
            Accept
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};
